import React from 'react';

const play = ({fill = '#000'}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31">
      <path fill={fill} d="M29.3 16.3h-28c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h28c.3 0 .5.2.5.5s-.3.5-.5.5zM20.2 6l-5.1-5-.2-.1h-.4l-.1.1-5.3 5c-.2.2-.2.5 0 .7l.4.2.3-.1 4.5-4.2v8.8c0 .3.2.5.5.5s.5-.2.5-.5V2.5l4.2 4.2c.2.2.5.2.7 0 .2-.2.2-.5 0-.7zM20.2 25.7l-5.1 5-.2.1h-.4l-.1-.1-5.3-5a.5.5 0 0 1 0-.7l.4-.2.3.1 4.5 4.2v-8.8c0-.3.2-.5.5-.5s.5.2.5.5v8.8l4.2-4.2c.2-.2.5-.2.7 0 .2.3.2.6 0 .8z" />
    </svg>
  );
};

export default play;


// WEBPACK FOOTER //
// ./src/components/svg-icons/ResizeIcon.jsx